// src/components/Footer.jsx
import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container-max">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="brand-logo-fallback">College Admin</div>
            <p>College Website Management System</p>
          </div>
          <div className="footer-links">
            <a href="/dashboard">Dashboard</a>
            <a href="/settings">Settings</a>
            <a href="/notifications">Notifications</a>
          </div>
          <div className="footer-copyright">
            <p>&copy; {currentYear} College Admin. All rights reserved.</p>
            <p>Built with React & Firebase</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;